import { getCountry } from '@iwIntlProvider/CountryProvider';
import { getDaysInMonth } from 'date-fns';
import _ from 'lodash';

import messages from './PersonModal.messages';
import { TSerialisedPeople } from './PersonModal.types';
import { getPeopleWithGuarantorStatus } from '../../../api/lendingAPI/CustomerStateAPIHelper';

export const validate = (people: TSerialisedPeople, values: any) => {
    let errors = {};

    if (!values.title) {
        errors = _.setWith(errors, 'title', messages.validNameRequired);
    }

    if (!values.firstName) {
        errors = _.setWith(errors, 'firstName', messages.validNameRequired);
    }

    if (!values.lastName) {
        errors = _.setWith(errors, 'lastName', messages.validNameRequired);
    }

    const day = values?.dateOfBirth?.day;
    const month = values?.dateOfBirth?.month;
    const year = values?.dateOfBirth?.year;

    if (!day || isNaN(day)) {
        errors = _.setWith(
            errors,
            'dateOfBirth.day',
            messages.validDateOfBirthRequired
        );
    }

    if (!month) {
        errors = _.setWith(
            errors,
            'dateOfBirth.month',
            messages.validDateOfBirthRequired
        );
    }

    if (!year || year.length !== 4 || isNaN(year)) {
        errors = _.setWith(
            errors,
            'dateOfBirth.year',
            messages.validDateOfBirthRequired
        );
    }

    if (
        day &&
        month &&
        year &&
        year.length === 4 &&
        // day out of range of month
        (day <= 0 || day > getDaysInMonth(new Date(`${year}-${month}-01`)))
    ) {
        errors = _.setWith(
            errors,
            'dateOfBirth.day',
            messages.validDateOfBirthRequired
        );
    }

    const peopleWithGuarantorStatus = getPeopleWithGuarantorStatus(
        people,
        values.uid
    );
    if (!values.email) {
        errors = _.setWith(errors, 'email', messages.emailAddressRequired);
    }
    if (
        // https://emailregex.com/
        !new RegExp(
            // eslint-disable-next-line no-useless-escape
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ).test(values.email)
    ) {
        errors = _.setWith(errors, 'email', messages.emailAddressRequired);
    }
    if (values.email) {
        const emailFound = _.find(peopleWithGuarantorStatus.email, {
            email: values.email
        });
        if (emailFound) {
            errors = _.setWith(
                errors,
                'email',
                messages.differentEmailRequired
            );
        }
    }
    if (!values.phones[0].number) {
        errors = _.setWith(
            errors,
            `phones[0].number`,
            messages.phoneNumberRequired
        );
    }
    values.phones.forEach(
        (
            phone: { number: string; type: string; uid: string },
            index: number
        ) => {
            if (values.phones[index] && phone.number) {
                const numberFound = _.find(peopleWithGuarantorStatus.phones, {
                    number: phone.number
                });
                if (numberFound) {
                    errors = _.setWith(
                        errors,
                        `phones[${index}].number`,
                        messages.differentPhoneNumberRequired
                    );
                }
            }
        }
    );

    if (!values.addresses || !values.addresses.length) {
        errors = _.setWith(errors, 'addresses', messages.addressRequired);
    }
    if (values.addresses) {
        const primaryAddress = values.addresses[0];

        if (primaryAddress && !primaryAddress.postcode) {
            errors = _.setWith(
                errors,
                `addresses[0].postcode`,
                messages.postcodeRequired
            );
        }
        if (
            primaryAddress?.postcode &&
            getCountry() === 'DE' &&
            !new RegExp(/^\d{5}$/).test(primaryAddress.postcode)
        ) {
            errors = _.setWith(
                errors,
                `addresses[0].postcode`,
                messages.postcodeRequired
            );
        }
        if (primaryAddress && !primaryAddress.town) {
            errors = _.setWith(
                errors,
                `addresses[0].town`,
                messages.townRequired
            );
        }
    }

    if (
        values.isGuarantor === true &&
        values.additionalGuarantorConsent !== true
    ) {
        errors = _.setWith(
            errors,
            'additionalGuarantorConsent',
            messages.consentForAdditionalGuarantorRequired
        );
    }

    return errors;
};
